import React, { memo } from 'react';
import Proptypes from 'prop-types';
import ImgGallery from 'common/components/modules/img-gallery'


const Image = ({
   story,
   isAgeVerificationRequired,
}) => {
   const images = story.full_src.map(item => {
      let originalClass = ''

      if(!story.is_sfw && isAgeVerificationRequired) {
         originalClass = '_default_thumbnail_blured_for_sfw'
      }

      return {
         original: item,
         originalClass: originalClass,
         isShowAgeVerifyButton: !!originalClass,
      }
   })

   return (
      <ImgGallery
         images={ images }
         showFullScreen={ false }
         classNameIconDiv='next-icon-classes mms-media-button-wrapper-bg'
         showPlayButton={ false }
         withZoomFuntion={ false }
         disableKeyDown={ true }
         showBullets={ true }
         isPreventFullScreenAction={ true }
         className='story-gallery-images'
      />
   )
};

Image.propTypes = {
   story: Proptypes.object,
   isAgeVerificationRequired: Proptypes.bool,
};

export default memo(Image);
